(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({behavior: 'instant'});
      }
    }, {once: true});
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mega-menu"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {    
    const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
    const mobileDrawer = document.querySelector('.mobile-drawer');
    const overlay = document.querySelector('.mobile-drawer-overlay');
    const mobileDrawerContent = document.querySelector('.mobile-drawer__content');
    const allDetails = document.querySelectorAll('.mega-menu-mobile__item details');
    const allSubmenus = document.querySelectorAll('.mega-menu-mobile__submenu');
    const submenuCloseDuration = 220;

    const handleSubmenuToggle = () => {
        const anySubmenuOpen = Array.from(allDetails).some(detail => detail.hasAttribute('open'));

        allSubmenus.forEach((submenu) => {
          const hasOpenChild = Boolean(submenu.querySelector('.mega-menu-mobile__submenu-item details[open]'));
          submenu.classList.toggle('has-open-child', hasOpenChild);
        });

        if (anySubmenuOpen) {
            mobileDrawerContent.classList.add('is-submenu-open');
        } else {
            mobileDrawerContent.classList.remove('is-submenu-open');
        }
    };

    const closeMobileSubmenu = (button, e) => {
      e.preventDefault();
      e.stopPropagation();

      const submenu = button.closest('.mega-menu-mobile__submenu');
      const details = submenu?.parentElement?.tagName === 'DETAILS'
        ? submenu.parentElement
        : null;

      if (!details) {
        return false;
      }

      details.classList.add('closing');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'false');

      setTimeout(() => {
        details.open = false;

        details.classList.remove('closing');
        handleSubmenuToggle();
      }, submenuCloseDuration);

      return true;
    };

    document.querySelectorAll('.mega-menu-mobile__back-button').forEach((btn) => {
      btn.addEventListener('touchend', function (e) {
        if (closeMobileSubmenu(this, e)) {
          this.dataset.touchHandled = 'true';
        }
      }, { passive: false });

      btn.addEventListener('click', function (e) {
        if (this.dataset.touchHandled === 'true') {
          this.dataset.touchHandled = '';
          return;
        }

        closeMobileSubmenu(this, e);
      });
    });

    if (mobileMenuToggle && mobileDrawer && overlay) {
      const syncDrawerViewport = () => {
        const header = document.querySelector('.header');
        if (!header) return;

        const headerRect = header.getBoundingClientRect();
        const headerBottom = headerRect.bottom;
        const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
        const availableHeight = Math.max(viewportHeight - headerBottom, 0);

        mobileDrawer.style.top = `${headerBottom}px`;
        mobileDrawer.style.height = `${availableHeight}px`;
        overlay.style.top = `${headerBottom}px`;
        overlay.style.height = `${availableHeight}px`;
      };

      const addViewportListeners = () => {
        window.addEventListener('resize', syncDrawerViewport);

        if (window.visualViewport) {
          window.visualViewport.addEventListener('resize', syncDrawerViewport);
          window.visualViewport.addEventListener('scroll', syncDrawerViewport);
        }
      };

      const removeViewportListeners = () => {
        window.removeEventListener('resize', syncDrawerViewport);

        if (window.visualViewport) {
          window.visualViewport.removeEventListener('resize', syncDrawerViewport);
          window.visualViewport.removeEventListener('scroll', syncDrawerViewport);
        }
      };

      const openDrawer = () => {
        syncDrawerViewport();
        mobileDrawer.classList.add('is-open');
        overlay.classList.add('is-open');
        document.body.classList.add('drawer-open');
        mobileMenuToggle.classList.add('is-open');
        mobileMenuToggle.setAttribute('aria-expanded', 'true');
        addViewportListeners();
      };

      const closeDrawer = () => {
        removeViewportListeners();
        mobileDrawer.classList.remove('is-open');
        overlay.classList.remove('is-open');
        document.body.classList.remove('drawer-open');
        mobileMenuToggle.classList.remove('is-open');
        mobileMenuToggle.setAttribute('aria-expanded', 'false');
      };

      mobileMenuToggle.addEventListener('click', () => {
        mobileDrawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
      });

      overlay.addEventListener('click', closeDrawer);
    }
    // safari submenu position bug fix
    allDetails.forEach(detail => {
        detail.addEventListener('toggle', handleSubmenuToggle);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
